export const PRODUCT = '/product'
export const HOME = '/'
export const CART = '/cart'
export const CHECKOUT = '/checkout'
export const ORDERS = '/orders'
export const COUPONS = '/my-account/coupons'
export const PROFILE = '/profile'
export const EDIT_PROFILE = '/editprofile'
export const ADDRESS = '/address'
export const CUSTOMER_SERVICE = '/contactus'
export const DELETE_ACCOUNT = '/delete-account'
export const TERMS_OF_SERVICE = '/terms-of-service'
export const PRIVACY_POLICY = '/privacy-policy'
export const LOGIN = '/login'
export const REGISTER = '/register'
export const LANGUAGE = '/language'
export const OVERVIEW = '/overview'
export const WISHLIST = '/wishlist'
export const CATEGORIES = '/categories'

export const HELPWITHORDER = '/help/order'
export const HELPNONORDER = '/help/non/order'
export const RECENTISSUES = '/recent/issues'
export const DELIVERYRELATED = '/delivery/related'
export const LOGINRELATED = '/login/related'
export const REFUNDRELATED = '/refund/related'
export const PAYEMENTRELATED = '/payment/related'
export const EMIRELATED = '/emi/related'

export const CANCELLATIONRELATED = '/cancel/related'
export const OFFERSRELATED = '/offers/related'
export const CONTACTUS = '/contactus'
